<ion-content>
  <div class="tw-p-8 tw-bg-neutral-100 tw-min-h-screen tw-flex tw-flex-col">
    <ng-content></ng-content>
  </div>
</ion-content>
